/**
 * Подготавливает диагностические блоки к работе с новым описанием.
 *
 * Для каждого блока остаётся только первый экземпляр. Его текст и история
 * очищаются, а идентификатор и остальные служебные данные сохраняются.
 * Функция не изменяет переданный массив и его объекты.
 *
 * @param {Array} blocks Текущее состояние диагностических блоков.
 * @param {Function} createInstanceId Функция создания идентификатора для блока без экземпляров.
 * @returns {Array} Новое состояние диагностических блоков.
 */
export const resetDraftBlocks = (blocks, createInstanceId = Date.now) =>
  blocks.map(block => {
    const firstInstance = block.instances[0];

    return {
      ...block,
      instances: [
        {
          ...firstInstance,
          id: firstInstance?.id ?? createInstanceId(),
          text: '',
          history: [''],
          historyIndex: 0,
        },
      ],
    };
  });
